import { render, staticRenderFns } from "./DictationLabel.vue?vue&type=template&id=625d3e84&"
import script from "./DictationLabel.vue?vue&type=script&lang=js&"
export * from "./DictationLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports